import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityPackingFeeQuery, EntityPackingFeesApi } from 'api';
import { entityPackingFeeQuery } from 'containers/Branding/Farm/Setting/commons/query';

export const createEntityPackingFee = createAsyncThunk(
  'entityPackingFee/createEntityPackingFee',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityPackingFeesApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPackingFee = createAsyncThunk(
  'entityPackingFee/findEntityPackingFee',
  async (option: EntityPackingFeeQuery, { rejectWithValue }) => {
    try {
      const response = await EntityPackingFeesApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}
export const updateEntityPackingFee = createAsyncThunk(
  'entityPackingFee/updateEntityPackingFee',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityPackingFeesApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityPackingFee = createAsyncThunk(
  'entityPackingFee/removeEntityPackingFee',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityPackingFeesApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
  query: entityPackingFeeQuery,
};

const entityPackingFeeSlice = createSlice({
  name: 'entityPackingFee',
  initialState,
  reducers: {
    reloadEntityPackingFee(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityPackingFee.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.tableList = data;
    });
  },
});

const { actions, reducer: entityPackingFeeReducer } = entityPackingFeeSlice;

export const { reloadEntityPackingFee } = actions;

export default entityPackingFeeReducer;
